<template>
  <gs-named-modal class="gs-refresh-controls"
    name="add-clawback-modal"
    :title="$t('frontend_groovesell_add_clawback')"
    bg-type="regular"
    @closed="onClose"
  >
    <div v-if="selectedAffiliate" class="flex gs-dialog-mobile-body">
      <div class="flex flex-col w-full px-4">
        <div class="mt-2">
          <!-- Amount Input -->
          <div class="w-full flex flex-row mb-4">
            <label class="w-1/3 mt-1 font-semibold text-grey-700">{{ $t('frontend_affiliate_index_amount') }}</label>
            <div class="w-2/3">
              <gd-currency-input v-model="clawback.amount" currency-code="USD" />
            </div>
          </div>

          <!-- Transaction ID Input -->
          <div class="w-full flex flex-row mb-4">
            <label class="w-1/3 mt-1 font-semibold text-grey-700">{{ $t('frontend_affiliate_index_transaction') }}</label>
            <text-input
              v-model="clawback.transactionId"
              :validator="$v.clawback.transactionId"
              :attribute="$t('frontend_affiliate_index_transaction_id')"
              class="w-2/3"
              :placeholder="$t('frontend_affiliate_index_transaction_id')"
            />
          </div>

          <!-- Comment Input -->
          <div class="w-full flex flex-row mb-4">
            <label class="w-1/3 mt-1 font-semibold text-grey-700">{{ $t('frontend_affiliate_index_comment') }}</label>
            <text-input
              v-model="clawback.comment"
              :validator="$v.clawback.comment"
              :attribute="$t('frontend_affiliate_index_comment')"
              class="w-2/3"
              :placeholder="$t('frontend_affiliate_index_comment')"
            />
          </div>

          <!-- Add Clawback Button -->
          <div class="flex flex-row w-full mb-6 justify-end">
            <gs-button class="mb-4" @click="addClawback()">
              {{ $t('frontend_affiliate_index_add_clawback') }}
            </gs-button>
          </div>
        </div>
      </div>
    </div>
  </gs-named-modal>
</template>

<script>
import { required, maxLength, decimal, minValue } from 'vuelidate/lib/validators';
import AffiliatePayment from '@/models/AffiliatePayment';
import SecondTierAffiliate from '@/models/SecondTierAffiliate';

export default {
  props: {
    selectedAffiliate: {
      type: Object,
      default: null,
    },
    filtersModel: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      clawback: {
        amount: 0,
        comment: '',
        transactionId: '',
      },
    };
  },
  methods: {
    async addClawback() {
      this.$v.clawback.$touch();
      if (this.$v.clawback.$invalid) return;

      this.$loader.start('addClawback');
      const affiliatePayment = new AffiliatePayment({
        affiliate_id: this.selectedAffiliate.id,
        amount: this.clawback.amount,
        payment_gateway: 0,
        note: this.clawback.comment,
        transaction_id: this.clawback.transactionId,
        type: 7,
        funnel: this.filtersModel.selectedFunnel,
      });

      await affiliatePayment.save();
      this.$root.$emit('modal-close', 'add-clawback-modal');
      
      const newSelectedAffiliate = await SecondTierAffiliate.params({
        funnels: this.filtersModel.selectedFunnel,
      }).$find(this.selectedAffiliate.id);
      this.$emit('updateSelectedAffiliate', newSelectedAffiliate);

      this.$loader.end('addClawback');
      this.$emit('changedSearchOrFilter');
    },
    onClose() {
      this.clawback = {
        amount: 0,
        comment: '',
        transactionId: '',
      };
    },
  },
  validations: {
    clawback: {
      amount: {
        required,
        decimal,
        minValue: minValue(0),
      },
      comment: {
        maxLength: maxLength(255),
      },
      transactionId: {
        maxLength: maxLength(255),
      },
    },
  },
};
</script>

<style scoped>
@media (max-width: 640px) {
  .gs-dialog-mobile-body { flex-wrap: wrap; min-width: 0; width: 100%; }
  .gs-dialog-mobile-body .flex-row { flex-wrap: wrap; }
  .gs-dialog-mobile-body .w-1\/4, .gs-dialog-mobile-body .w-1\/3, .gs-dialog-mobile-body .w-1\/2, .gs-dialog-mobile-body .w-2\/3, .gs-dialog-mobile-body .w-3\/4 { width: 100%; }
}
</style>
